import { Component, OnInit } from '@angular/core';


export interface RouteInfo {
    path: string;
    menuTitle: string;
    pageTitle: string;
    icon: string;
    class: string;
    showSideMenu: boolean;
}

export const ROUTES: RouteInfo[] = [
    { path: '/dashboard', menuTitle: 'Dashboard', pageTitle: 'Program Dashboard', icon: 'nc-chart-bar-32', showSideMenu: true, class: '' },
    { path: '/scholar-tracker', menuTitle: 'Scholar Tracker', pageTitle: 'Scholar Tracker', icon: 'nc-hat-3', showSideMenu: true, class: '' },
    { path: '/breeding-costs', menuTitle: 'Breeding Costs', pageTitle: 'Axie Breeding Costs Calculator', icon: 'nc-box-2', showSideMenu: true, class: '' },
    { path: '/rates-calc', menuTitle: 'Rates Calculator', pageTitle: 'Rates Calculator', icon: 'nc-money-coins', showSideMenu: true, class: '' },
    { path: '/about-us', menuTitle: 'About Us', pageTitle: 'About Us', icon: '', showSideMenu: false, class: '' },
    { path: '/faqs', menuTitle: 'F.A.Qs', pageTitle: 'Frequently Asked Questions', icon: '', showSideMenu: false, class: '' },
    { path: '/contact-us', menuTitle: 'Contact Us', pageTitle: 'Contact Us', icon: '', showSideMenu: false, class: '' },
    // { path: '/manage-portfolio', menuTitle: 'Manage Portfolio',  pageTitle:'Manage Portfolio',    icon:'nc-settings',       class: '' },
    { path: '/donate', menuTitle: 'Donate a beer!', pageTitle: 'Donation Addresses', icon: 'nc-spaceship', showSideMenu: true, class: 'active-pro' },
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem.showSideMenu);
    }
}
